import { render } from "./OutputBottomBar.vue?vue&type=template&id=49c5391c&scoped=true"
import script from "./OutputBottomBar.vue?vue&type=script&lang=js"
export * from "./OutputBottomBar.vue?vue&type=script&lang=js"

import "./OutputBottomBar.vue?vue&type=style&index=0&id=49c5391c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c5391c"]])

export default __exports__